import { Column, ColumnWithFunctionAccessor } from 'react-table'

import { monthDayYear } from '../../../../../utils/dateTools'
import { formatAsCurrencyOrZero } from '../../../../../utils/priceTools'
import { InvoiceCell } from './InvoiceCell'
import { RelatedOrderCell } from './RelatedOrderCell'
import { TableDataInvoice } from './types'

export const dateColumn = <
  TData extends TableDataInvoice,
>(): ColumnWithFunctionAccessor<TData> => ({
  Header: 'Ship Date',
  id: 'date',
  className: 'noWrapColumn',
  accessor: (invoice) => monthDayYear(invoice.date),
  disableSortBy: false,
  sortType: (a, b) => {
    if (a.original.date && b.original.date) {
      if (a.original.date === b.original.date) {
        return 0
      }
      if (a.original.date > b.original.date) {
        return 1
      }
    }
    return -1
  },
  Cell: InvoiceCell,
})

export const invoiceNumberColumn = <
  TData extends TableDataInvoice,
>(): ColumnWithFunctionAccessor<TData> => ({
  Header: 'Invoice No.',
  id: 'invoiceNumber',
  className: 'noWrapColumn',
  accessor: (invoice) => `#${invoice.invoiceNumber}`,
  disableSortBy: true,
  Cell: InvoiceCell,
})

export const totalColumn = <
  TData extends TableDataInvoice,
>(): ColumnWithFunctionAccessor<TData> => ({
  Header: 'Total',
  id: 'total',
  className: 'totalColumn',
  accessor: (invoice) => formatAsCurrencyOrZero({ amount: invoice.total }),
  disableSortBy: true,
  Cell: InvoiceCell,
})

export const relatedOrderColumn = <TData extends TableDataInvoice>(): Column<TData> => ({
  Header: '',
  id: 'tracking',
  className: 'desktopOnly textRight',
  accessor: 'invoiceId',
  disableSortBy: true,
  Cell: RelatedOrderCell,
})
